import "./EventTable.css";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { getEvents } from "../../utils/api";
import { Table, Button } from "antd";
import { RightOutlined } from "@ant-design/icons";
import moment from "moment";

function EventTable({
  authStore,
  navStore,
  store,
  userId,
  startDate,
  endDate,
  bounds,
  selected,
  setSelected,
}) {
  const columns = [
    {
      title: "Report No.",
      dataIndex: "reportnum",
      key: "reportnum",
    },
    {
      title: "Type",
      dataIndex: "eventtype",
      key: "eventtype",
    },
    {
      title: "Start",
      dataIndex: "eventstart",
      key: "eventstart",
    },
    {
      title: "End",
      dataIndex: "eventend",
      key: "eventend",
    },
    {
      title: "Duration",
      dataIndex: "eventduration",
      key: "eventduration",
    },

    {
      title: "Select",
      key: "action",
      render: (item) => (
        <Button
          icon={<RightOutlined />}
          onClick={() => setSelected(item.reportnum, item)}
        ></Button>
      ),
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (userId && startDate && endDate) {
        const isoStart = moment(startDate).toDate().toISOString();
        const isoEnd = moment(endDate).add(1, "day").toDate().toISOString();
        const events = await getEvents(userId, isoStart, isoEnd);
        store.events = events.data;
      }
    };
    fetchData();
  }, [userId, startDate, endDate]);

  const formatDuration = (ms) => {
    if (ms < 0) ms = -ms;
    const time = {
      day: Math.floor(ms / 86400000),
      hour: Math.floor(ms / 3600000) % 24,
      minute: Math.floor(ms / 60000) % 60,
      second: Math.floor(ms / 1000) % 60,
      millisecond: Math.floor(ms) % 1000,
    };
    return Object.entries(time)
      .filter((val) => val[1] !== 0)
      .map(([key, val]) => `${val} ${key}${val !== 1 ? "s" : ""}`)
      .join(", ");
  };

  const mappedData = store.events
    .map((x) => {
      return {
        key: x.reportnum,
        reportnum: x.reportnum,
        eventtype: x.eventtype,
        eventstart: moment(x.eventstart).format("MMMM Do YYYY, h:mm:ss a"),
        eventend: moment(x.eventend).format("MMMM Do YYYY, h:mm:ss a"),
        startDate: new Date(x.eventstart),
        endDate: new Date(x.eventend),
        eventduration: formatDuration(x.eventduration * 1000),
      };
    })
    .filter((x) => {
      if (!bounds[0] || !bounds[1]) {
        return true;
      }
      return (
        x.startDate.getTime() >= bounds[0].getTime() &&
        x.startDate.getTime() <= bounds[1].getTime()
      );
    })
    .filter((x) => {
      if (selected) {
        return x.reportnum === selected;
      } else {
        return true;
      }
    });

  return (
    <div className="EventTable">
      <Table dataSource={mappedData} columns={columns} size="small" />
    </div>
  );
}

export default observer(EventTable);
